import type { FC } from 'react';

import { EntityLifecycleFilter } from '@backstage/plugin-catalog-react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

import { SelectFilter } from './SelectFilter';

const options = {
  'in-development': 'In Development',
  'in-ideation': 'In Ideation',
  'in-integration': 'In Integration',
  'productive': 'Productive',
};

const solutionOptions = [
  ['in-ideation', 'In Ideation'],
  ['in-selection', 'In Selection'],
  ['in-integration', 'In Integration'],
  ['productive', 'Productive'],
  ['phasing-out', 'Phasing-Out'],
  ['retired', 'Retired'],
  ['discarded', 'Discarded'],
] as const;

type Props = {
  mobile?: boolean;
  solution?: boolean;
  visibleOptions?: readonly (keyof typeof options)[];
};

export const LifecycleFilter: FC<Props> = ({ mobile: forceMobile, solution, visibleOptions }) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const items = useMemo(
    () =>
      (solution ? solutionOptions : Object.entries(options))
        .filter(
          ([value]) =>
            visibleOptions?.includes(value as keyof typeof options) ?? true,
        )
        .map(([value, label]) => ({ label, value })),
    [solution, visibleOptions],
  );
  return (
    <SelectFilter
      Filter={EntityLifecycleFilter}
      items={items}
      label="Lifecycle"
      mobile={forceMobile ?? mobile}
      multiple
      name="lifecycles"
    />
  );
};
